import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { Affiliate, Block, Landing, LayoutQuery, Maybe, Setting } from '@/app/graphql/generated'

interface ILayoutStore {
  messengers: (Setting | null)[]
  socials: (Setting | null)[]
  phones: (Setting | null)[]
  schedule: (Setting | null)[]
  email: {
    name: Maybe<string> | undefined
    value: Maybe<string> | undefined
  } | null
  pages: Maybe<Block>[]
  landing: Landing | null
  affiliates: Maybe<Affiliate>[] | undefined | null
  setData: (obj: LayoutQuery) => void
  setSocials: (obj: Setting[]) => void
  typeSite: ITypeSite
  setTypeSite: (e: ITypeSite) => void
}

export type ITypeSite = 'offline' | 'online' | 'online-espanol' | 'online-deutsch' | 'kids' | null

const useLayout = create<ILayoutStore>()(
  devtools((set) => ({
    messengers: [],
    socials: [],
    phones: [],
    schedule: [],
    email: null,
    pages: [],
    landing: null,
    affiliates: [],
    typeSite: null,
    setTypeSite: (slug: ITypeSite) => {
      set({
        typeSite: slug,
      })
    },
    setSocials: (data) => {
      if (!data) return
      set({
        socials: data?.filter((el) => el && el.name === 'messengers'),
      })
    },
    setData: (data) => {
      if (!data) return

      const messengers = data.settings?.settings?.filter((el) => el && el.name === 'messengers')

      const schedule = data.settings?.settings?.filter((el) => el?.name === 'schedule')

      const email = data.settings?.settings?.filter((el) => el?.name === 'email')

      const phones = data.settings?.settings?.filter((el) => el?.name === 'phones')

      const pages = data.page?.blocks ?? []

      set({
        messengers: messengers,
        schedule: schedule,
        phones: phones,
        pages: pages,
        affiliates: data.affiliates,
        landing: data.page?.landing,
        email: {
          name: email?.[0]?.key,
          value: email?.[0]?.value,
        },
      })
    },
  })),
)

export default useLayout
